import { createAction, props } from '@ngrx/store';

export const LOGIN_OTP_SEND = createAction(
  '[LOGIN OTP] - send',
  props<{ telefono: string }>()
);

export const LOGIN_OTP_SEND_SUCCESS = createAction(
  '[LOGIN OTP] - send success',
  props<{
    esito: string;
    seed: string;
    otpTtlSeconds?: number;
    telefono: string;
    maxTentativi?: number;
    msgCode?: string;
  }>()
);

export const LOGIN_OTP_SEND_FAIL = createAction(
  '[LOGIN OTP] - send fail',
  props<{ error: any }>()
);

export const LOGIN_OTP_VERIFY = createAction(
  '[LOGIN OTP] - verify',
  props<{
    otp: string;
    seed: string;
    username: string;
  }>()
);

export const LOGIN_OTP_VERIFY_SUCCESS = createAction(
  '[LOGIN OTP] - verify success',
  props<{
    esito: string;
    msgCode?: string;
    username: string;
  }>()
);

export const LOGIN_OTP_VERIFY_FAIL = createAction(
  '[LOGIN OTP] - verify fail',
  props<{ error: any }>()
);

export const LOGIN_OTP_RESET = createAction('[LOGIN OTP] - reset');

export const LOGIN_OTP_PRELOAD = createAction(
  '[LOGIN OTP] - preload',
  props<{ telefono: string }>()
);
